// @flow

import styled from 'styled-components';

import animatedContent from '../../helpers/animatedContent';

export default styled.a`
  display: flex;
  flex: 1;
  align-items: space-between;
  cursor: pointer;
  ${animatedContent};

  &:hover {
    background-color: ${props => props.theme.rowHoverColor};
  }
`;
